<template>
  <div class="kids-age">
    <h2>{{ $t('enter_age') }}</h2>

    <form v-on:submit.prevent="sendDate" style="">
      <div class="input-group">
        <date-dropdown
          class="form-controlx"
          name="theDates"
          v-bind:default="theDOB"
          v-model="theDOB"
          v-bind:months-names="$t('months')"
          v-bind:min="(curYear - 18).toString()"
          v-bind:max="curYear.toString()"
        />
        <button class="btn btn-outline-light" type="submit">
          {{ $t('enter') }}
        </button>
      </div>
    </form>
  </div>
</template>

<i18n>
  {
  "el": {
  "enter_age": "Εισάγετε την ημερομηνία γέννησης του παιδιού",
  "enter": "Εισαγωγή",
  "months": "Ιανουάριος, Φεβρουάριος, Μάρτιος, Απρίλιος, Μάιος, Ιούνιος, Ιούλιος, Αύγουστος, Σεπτέμβριος, Οκτώβριος, Νοέμβριος, Δεκέμβριος"
  },
  "en": {
  "enter_age": "Enter your child's day of birth",
  "enter": "Enter",
  "months": "January, February, March, April, May, June, July, August, September, October, November, December"
  }
  }
</i18n>

<script>
import DateDropdown from 'vue-date-dropdown'

export default {
  name: 'KidsAgeForm',
  data() {
    return {
      theDOB: this.theDate,
      curYear: new Date().getFullYear()
    }
  },
  components: {
    DateDropdown
  },
  props: ['theDate'],
  methods: {
    sendDate: function() {
      /**
       * TODO: DOCUMENT THIS
       */
      this.$emit('myDate', this.theDOB)
    },
    maxDate: function() {
      /**
       * TODO: DOCUMENT THIS
       * !SHOULD IMPROVE?
       */
      const today = new Date()
      const thisYear = today.getFullYear()
      let thisMonth = today.getMonth() + 1
      const thisDay = today.getDate()

      if (thisMonth < 10) thisMonth = '0' + thisMonth
      if (thisDay < 10) thisMonth = '0' + thisDay

      return thisYear + '-' + thisMonth + '-' + thisDay
    }
  }
}
</script>
